var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M5.72205e-06 0L0 30H6.6L6.55173 6.55172L30 6.6V1.14441e-06L5.72205e-06 0Z","fill":"#00FF85","key":0}),React.createElement("path",{"d":"M8.24119 3.84671L3.44119 8.64671L24.4412 29.6467L29.2412 24.8467L8.24119 3.84671Z","fill":"#00FF85","key":1})]);
}

ArrowLeft.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 30 30","fill":"none"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
